import React, { memo, useMemo } from 'react';
import { compose } from '@beef/utils';
import classNames from 'classnames/bind';
import { StepContent } from "./components/StepContent";
import { StepNumber } from "./components/StepNumber";
import { withClickingWrapper, withTimerSettingWrapper } from "./hocs";
import style from "./styles.pcss";
var cn = classNames.bind(style);
var _Step = /*#__PURE__*/memo(function (_ref) {
  var customDescription = _ref.customDescription,
    description = _ref.description,
    handleClick = _ref.handleClick,
    isClickable = _ref.isClickable,
    selected = _ref.selected,
    stepNumber = _ref.stepNumber,
    _ref$testName = _ref.testName,
    testName = _ref$testName === void 0 ? 'Step' : _ref$testName,
    title = _ref.title,
    transitionTime = _ref.transitionTime;
  var Tag = useMemo(function () {
    return isClickable ? 'button' : 'div';
  }, [isClickable]);
  return /*#__PURE__*/React.createElement(Tag, {
    className: cn('step', {
      'step--clickable': isClickable
    }),
    "data-component": testName,
    onClick: handleClick,
    "data-t-id": "src-Step"
  }, /*#__PURE__*/React.createElement(StepNumber, {
    isClickable: isClickable,
    selected: selected,
    stepNumber: stepNumber,
    transitionTime: transitionTime,
    "data-t-id": "src-Step"
  }), /*#__PURE__*/React.createElement(StepContent, {
    customDescription: customDescription,
    description: description,
    isClickable: isClickable,
    selected: selected,
    title: title
  }));
});
_Step.displayName = _Step.name;
export var Step = compose(withClickingWrapper, withTimerSettingWrapper)(_Step);